import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

const APPLIANCES = [
  { name: 'Refrigerator ', noteText: '(Including ice maker)', price: '$3,000' },
  { name: 'Dishwasher', price: '$3,000' },
  { name: 'Clothes washer', price: '$3,000' },
  { name: 'Clothes dryer', price: '$3,000' },
  { name: 'Water heater', price: '$5,000' },
  { name: 'Range', price: '$3,000' },
  { name: 'Oven', price: '$3,000' },
  { name: 'Double oven', price: '$3,000' },
  { name: 'Cooktop', price: '$3,000' },
  { name: 'Built-in microwave', price: '$3,000' },
  { name: 'Garbage disposal', price: '$3,000' },
  { name: 'Standalone freezer', price: '$3,000' },
  { name: 'Trash compactor', price: '$3,000' },
  { name: 'Food spoilage', price: '$250**' },
];

const SYSTEMS = [
  {
    name: 'Central air conditioning/heat pump',
    noteText: '(Electric only)',
    price: '$7,500',
  },
  { name: 'Central home heating', price: '$7,500' },
  {
    name: 'Boilers',
    noteText: '(Including hydronic, steam, radiator, and baseboard heating systems)',
    price: '$3,000',
  },
  { name: 'Ductwork', price: '$1,000' },
  { name: 'HVAC refrigerant top-off', price: '$200' },
  {
    name: 'Interior electrical',
    noteText: '(Including AC wiring, fuses, receptacles)',
    price: '$3,000',
  },
  {
    name: 'Interior plumbing',
    noteText: '(Including clogs in sinks,  toilets and tubs)',
    price: '$3,000',
  },
];

const FIXTURES = [
  { name: 'Ceiling fans' },
  { name: 'Garage door ', noteText: '(Including wheels, tracks)' },
  { name: 'Hard-wired doorbell system' },
  { name: 'Kitchen exhaust fan' },
  { name: 'Instant hot/cold water dispenser' },
  { name: 'Attic/whole house fan' },
];

@Component({
  selector: 'hsc-coverage-limits',
  imports: [CommonModule],
  template: `
    <div id="coverage-limits" class="bolt-container flex w-full flex-col gap-8 bg-white p-12">
      <h2 class="bolt-heading-sm text-charcoal text-center">Coverage limits*</h2>
      <div class="grid grid-cols-3 gap-8">
        <div class="flex flex-col text-center">
          <span class="bolt-body-copy-lg font-medium!">Aggregate Limit:</span>
          <span class="bolt-body-copy-md bolt-sans-serif">$15,000 per 12 months</span>
        </div>
        <div class="flex flex-col text-center">
          <span class="bolt-body-copy-lg font-medium!">Service fee:</span>
          <span class="bolt-body-copy-md bolt-sans-serif">$150 per claim</span>
        </div>
        <div class="flex flex-col text-center">
          <span class="bolt-body-copy-lg font-medium!">Coverage waiting period:</span>
          <span class="bolt-body-copy-md bolt-sans-serif">30 days from effective date</span>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-8">
        <div class="flex flex-col gap-4 bg-[#F0EDE8] p-6">
          <h2 class="bolt-heading-xs text-charcoal">Appliances</h2>
          <div class="flex flex-col gap-2">
            @for (appliance of appliances; track appliance.name; let i = $index) {
              <div class="flex flex-row items-center justify-between">
                <span class="bolt-body-sm font-medium"
                  >{{ appliance.name }}
                  @if (appliance.noteText) {
                    <span class="font-normal">{{ appliance.noteText }}</span>
                  }
                </span>
                <span class="bolt-body-sm">{{ appliance.price }}</span>
              </div>
            }
          </div>
          <div class="mt-auto flex w-full flex-col items-end justify-end gap-1">
            <span class="bolt-subheading-md text-charcoal">*per 12 months</span>
            <span class="bolt-subheading-md text-charcoal">**per claim</span>
          </div>
        </div>

        <div class="flex flex-col gap-4 bg-[#F0EDE8] p-6">
          <h2 class="bolt-heading-xs text-charcoal">Systems</h2>
          <div class="mb-4 flex flex-col gap-2">
            @for (system of systems; track system.name; let i = $index) {
              <div class="flex flex-row items-center justify-between">
                <span class="bolt-body-sm font-medium"
                  >{{ system.name }}
                  @if (system.noteText) {
                    <span class="font-normal">{{ system.noteText }}</span>
                  }
                </span>
                <span class="bolt-body-sm">{{ system.price }}</span>
              </div>
            }
          </div>

          <h2 class="bolt-heading-xs text-charcoal">Household items</h2>
          <div class="flex flex-col gap-2">
            <div class="flex flex-row items-center justify-between">
              <span>Aggregate limit for items</span>
              <span>$3,000</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            @for (fixture of fixtures; track fixture.name; let i = $index) {
              <div class="flex flex-row items-center justify-between">
                <span class="bolt-body-sm font-medium"
                  >{{ fixture.name }}
                  @if (fixture.noteText) {
                    <span class="font-normal">{{ fixture.noteText }}</span>
                  }
                </span>
              </div>
            }
          </div>
          <div class="flex w-full flex-1 flex-col items-end justify-end gap-1">
            <span class="bolt-subheading-md text-charcoal">*per 12 months</span>
            <span class="bolt-subheading-md text-charcoal">**per claim</span>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class CoverageLimits {
  readonly appliances = APPLIANCES;
  readonly systems = SYSTEMS;
  readonly fixtures = FIXTURES;
}
